
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogIn, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/auth";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import { cn } from "@/lib/utils";

interface UserAuthButtonsProps {
  mobile?: boolean;
}

const UserAuthButtons = ({ mobile = false }: UserAuthButtonsProps) => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const { language } = useLanguage();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate("/");
    } catch (error) {
      console.error("Sign out error:", error);
      navigate("/");
    }
  };

  if (user) {
    return (
      <Button
        variant="ghost"
        size="sm"
        onClick={handleSignOut}
        className={cn(
          "flex items-center gap-1",
          mobile ? "w-full justify-center" : "ml-2"
        )}
      >
        <LogOut className="h-4 w-4" />
        {t('common.logout', language)}
      </Button>
    );
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => navigate("/login")}
      className={cn(
        "flex items-center gap-1",
        mobile ? "w-full justify-center" : "ml-2"
      )}
    >
      <LogIn className="h-4 w-4" />
      {t('common.login', language)}
    </Button>
  );
};

export default UserAuthButtons;
